import VerifyDomainContainer from './verify_domain_container';

const VerifyDomain = VerifyDomainContainer;
export default VerifyDomain;
